import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { RATINGS } from '../../../../lib/schema.js';
import RatingLabel from '../../../RatingLabel.jsx';

StakeholderInterestsFilter.defaultProps = {
  selectedStakeholderInterests: [],
};

function StakeholderInterestsFilter({
  selectedStakeholderInterests,
  navigateAction,
}) {
  const selectedCount = selectedStakeholderInterests.length;
  const handleSelect = useCallback(
    (stakeholderInterest) =>
      navigateAction({
        stakeholderInterests: stakeholderInterest
          ? xor(selectedStakeholderInterests, [stakeholderInterest])
          : [],
      }),
    [selectedStakeholderInterests]
  );

  const renderMenuItem = useCallback(
    (stakeholderInterest) => (
      <React.Fragment key={stakeholderInterest}>
        <MenuItem
          active={selectedStakeholderInterests.includes(stakeholderInterest)}
          eventKey={stakeholderInterest}
          onSelect={handleSelect}
        >
          <RatingLabel rating={stakeholderInterest} />
        </MenuItem>
      </React.Fragment>
    ),
    [selectedStakeholderInterests]
  );
  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Stakeholder Interest</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="stakeholder-interest-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {RATINGS.HIGH_MEDIUM_LOW.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default StakeholderInterestsFilter;
